import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/atoms/Button';
import Heading from 'components/atoms/Heading';
import Text from 'components/atoms/Text';
import CustomModal from 'components/organisms/Modal';
import useLoginSSO from 'hooks/useLoginSSO';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { toggleTokenExpired } from 'store/system';

const MainModals: React.FC = () => {
  const dispatch = useAppDispatch();
  const tokenExpired = useAppSelector((state) => state.system.modalOpen.tokenExpired);
  const { t } = useTranslation();
  const { hrefLoginSSO } = useLoginSSO();
  return (
    <>
      <CustomModal isOpen={tokenExpired} className="ssoModal" iconName="closeWhite">
        <div className="t-ssoModal">
          <div className="t-ssoModal_title">
            <Heading
              type="h5"
              content={t('modal.please_login')}
              modifiers={[
                'center',
                'letterSpacing',
                '700',
                'primaryReverseLinear',
              ]}
            />
          </div>
          <div className="t-ssoModal_content">
            <Text modifiers={['400', 'md', 'davysGrey', 'center']}>
              {t('modal.token_expired')}
            </Text>
          </div>
          <div className="t-ssoModal_buttons">
            <div className="t-ssoModal_buttons-item">
              <Button
                modifiers={['pd-x-22', 'outline', '700']}
                handleClick={
                  () => dispatch(toggleTokenExpired(false))
                }
              >
                {t('ratingForm.cancelBtn')}
              </Button>
            </div>
            <div className="t-ssoModal_buttons-item" onClick={hrefLoginSSO}>
              <Button
                modifiers={['pd-x-22', 'primaryLinearReverse', 'white', '700']}
              >
                {t('modal.login')}
              </Button>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default MainModals;
